<template>
  <Modal v-model="isShow" @on-visible-change="onVisibleChange" :title="title">
    <Form ref="form" :model="form" :rules="rules" :label-width="100" inline>
      <FormItem label="任务名称：" prop="task_name">
        <Input v-model="form.task_name" placeholder="请输入任务名称" style="width:200px;"></Input>
      </FormItem>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="isShow=false">取消</Button>
      <Button type="primary" size="large" @click="onOk">确定</Button>
    </div>
  </Modal>
</template>

<script>
export default {
  name: 'exports-modal',
  props: {
    title: {
      type: String,
      required: true
    },
    type: {
      type: Number,
      required: true
    },
    params: {
      type: Object,
      required: true
    },
    value: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      form: {
        task_name: ''
      },
      rules: {
        task_name: [{ required: true, message: '任务名称不能为空' }]
      },
      event: {
        onSuccess: 'onSuccess',
        onVisibleChange: 'onVisibleChange'
      },
      isShow: this.value
    }
  },
  watch: {
    value(val) {
      this.isShow = val
    }
  },
  methods: {
    onOk() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.onVisibleChange(false)
        this.$http.post('/api/export/task', Object.assign({
          type: this.type,
          task_name: this.form.task_name,
          order_type: this.params.order_type || 0,
        }, this.params)).then(() => {
          this.$emit(this.event.onSuccess)
        })
      })
    },
    onVisibleChange(visible) {
      this.$emit('input', visible)
    }
  },
}
</script>

<style lang="" scoped>
</style>
